import { render, staticRenderFns } from "./NotifAndSetti.vue?vue&type=template&id=b5422f42&scoped=true&"
import script from "./NotifAndSetti.vue?vue&type=script&lang=js&"
export * from "./NotifAndSetti.vue?vue&type=script&lang=js&"
import style0 from "./NotifAndSetti.vue?vue&type=style&index=0&id=b5422f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5422f42",
  null
  
)

export default component.exports